// projects/humanresources-personnel/src/assets/i18n/*/hr-per-foreign-language.json
export class HrPerForeignLanguageKey {
    private static readonly keyPrefix = 'hrPerForLang';
    public static title = `${HrPerForeignLanguageKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerForeignLanguageKey.keyPrefix}.pageHeader`;
    public static examDate = `${HrPerForeignLanguageKey.keyPrefix}.examDate`;
    public static languageScore = `${HrPerForeignLanguageKey.keyPrefix}.languageScore`;
    public static languageLevel = `${HrPerForeignLanguageKey.keyPrefix}.languageLevel`;
    public static languageType = `${HrPerForeignLanguageKey.keyPrefix}.languageType`;
    public static languageExamType = `${HrPerForeignLanguageKey.keyPrefix}.languageExamType`;
    public static integrationGetDate = `${HrPerForeignLanguageKey.keyPrefix}.integrationGetDate`;
    public static integrationSource = `${HrPerForeignLanguageKey.keyPrefix}.integrationSource`;
    public static getExamScore = `${HrPerForeignLanguageKey.keyPrefix}.getExamScore`;
}
